import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
  useBaseData,
} from "../../../utils/utils";

import { GridSortItem } from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { useEncounterCreationGate } from "../../../hooks/use-encounter-creation-gate";
import { AppointmentTypeControllerApi } from "../../../services";

type Params = {
  pagination?: DGT_Pagination;
  gridSorting?: GridSortItem[];
  archive?: boolean;
  searchString?: string;
  status?: boolean;
  xTENANTID?: string;
};

/**
 * @author [Atish Bagate]
 */
export const useAppointmentTypeGetAll = (params: Params): useBaseData<any> => {
  const prevPage = useRef<number>(params?.pagination?.page ?? 0);

  const pageIndex = getPageIndexWhileSearch({
    pagination: params?.pagination ?? { page: 0, pageSize: 100 },
    searchKey: params?.searchString,
    prevPage,
  });
  const pageSize = getPageSize(params?.searchString, params?.pagination);

  const sortData = params?.gridSorting?.[0];
  const skip = useEncounterCreationGate();

  return useQuery({
    queryKey: ["provider-group-appointment-types-list", params],
    enabled: !skip,
    refetchOnWindowFocus: false,
    queryFn: async () =>
      new AppointmentTypeControllerApi(getConfigObject())
        .getAllAppointmentTypes(
          pageIndex ?? 0, //page
          pageSize ?? 100, //size
          sortData?.sort ?? undefined, //sortBy
          sortData?.field, //sortDirection
          params?.status, //status
          params?.archive, //archive
          params?.searchString, //searchString
          params?.xTENANTID
        )
        .then((res) => res?.data),
  });
};
